import * as React from "react";
import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width="29"
    height="29"
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.4989 2.4082C7.83611 2.40941 2.41553 7.83 2.41553 14.4927C2.41553 21.1555 7.83611 26.5761 14.5001 26.5761C21.1616 26.5761 26.5822 21.1555 26.5834 14.4927C26.5834 7.83 21.1628 2.40941 14.4989 2.4082ZM14.5001 24.1594C9.1689 24.1594 4.83219 19.8227 4.83219 14.4927C4.83219 9.16279 9.1689 4.82608 14.4989 4.82487C19.83 4.82608 24.1667 9.16279 24.1667 14.4927C24.1655 19.8227 19.8288 24.1594 14.5001 24.1594Z"
      fill="currentColor"
    />
    <path
      d="M14.5001 13.2844H9.66675V15.7011H14.5001V19.3333L19.3395 14.4939L14.5001 9.65576V13.2844Z"
      fill="currentColor"
    />
  </svg>,
  "ArrowDetailIcon"
);
